<template>
  <div class="card" :class="cardClasses">
    <div class="card-header">
      <span v-if="pulse" class="pulsetag"></span>
      <h4>Pedido: {{ title }}</h4>
    </div>
    <div class="card-body">
      <h6><strong><i class="fa fa-user-circle"></i> Cliente: {{ client }}</strong></h6>
      <h6><strong><i class="fa fa-calendar"></i> {{ datetime }}</strong></h6>
      <span class="tag tag-pill tag-warning mt-1 mb-1">{{ status }}</span><br>
      <span><i class="fa fa-car"></i> Entrega: {{ deliveryType }}</span><br>
      <span><i class="fa fa-credit-card-alt"></i> Pagamento: {{ paymentMethod }}</span><br>
      <span><i class="fa fa-building"></i> Unidade: {{ local }}</span>

    </div>
    <div class="card-footer">
      <span><i class="fa fa-shopping-basket mt-2"></i> Itens: {{ quantity }}</span><br>
      <span><i class="fa fa-car"></i> Frete: R${{ shipping }}</span><br>
      <span><i class="fa fa-shopping-cart"></i> Total: R${{ total }}</span><br>
      <span><i class="fa fa-plus"></i> Total Plus: R${{ totalplus }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardOrder',
  props: ['title', 'client', 'datetime', 'status', 'deliveryType', 'paymentMethod', 'local', 'quantity', 'shipping', 'total', 'totalplus', 'classes', 'initClasses', 'pulse'],
  data () {
    return {
      cardClasses: '',
    }
  },
  created () {
    this.cardClasses = this.$props.classes;
    if (this.$props.initClasses !== '') {
      this.cardClasses += ` ${this.$props.initClasses}`;
      setTimeout(() => {
        this.cardClasses = this.$props.classes;
      }, 2000);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CardOrder.vue